import { chakra } from '@stockx/ui';

export const NavFooter = chakra('div', {
  baseStyle: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    margin: '13px 0px 20px',
  },
});
